import "core-js/modules/es6.array.map";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.object.create";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.assign";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.assign";

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

import React, { Component } from 'react';
import Navigation from '../../../components/Navigation';
import LayoutDefault from '../../../components/LayoutDefault';

var Entry =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(Entry, _Component);

  function Entry() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _this.childProps = function () {
      var _this$props = _this.props,
          children = _this$props.children,
          props = _objectWithoutPropertiesLoose(_this$props, ["children"]);

      return Object.assign({}, props, {}, _this.props.childProps);
    };

    _this.children = function () {
      return React.Children.map(_this.props.children, function (element) {
        return React.cloneElement(element, _this.childProps());
      });
    };

    return _this;
  }

  var _proto = Entry.prototype;

  _proto.render = function render() {
    var Layout = this.props.layout;
    return React.createElement(Layout, null, this.children());
  };

  return Entry;
}(Component);

Entry.Navigation = Navigation;
Entry.defaultProps = {
  layout: LayoutDefault
};
export { Entry as default };